import { render, staticRenderFns } from "./AnimaOmniView.vue?vue&type=template&id=6e1008a6&scoped=true&"
import script from "./AnimaOmniView.vue?vue&type=script&lang=js&"
export * from "./AnimaOmniView.vue?vue&type=script&lang=js&"
import style0 from "./AnimaOmniView.vue?vue&type=style&index=0&id=6e1008a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1008a6",
  null
  
)

export default component.exports